import { callApi } from "../helpers/Api";

export const postContact = (requestBody = {}) => {
    const functionUrl = `contact_us`;
    const isBackground = true;

    try {
        return callApi({ functionUrl, requestBody, isBackground }).then((response) => {
            return response;
        });
    } catch (error) {
        console.error("API error: ", error);
        return false;
    }
};